<template>
  <div class="card">
    <div class="card-header">
      <h2>Editar TOC</h2>
    </div>

    <div class="card-body">
      <div class="form-grid">

        <!-- Nombre -->
        <div class="form-row">
          <label for="arcgis-nombre">Nombre <span class="required-indicator">*</span></label>
          <input
            id="arcgis-nombre"
            type="text"
            class="input"
            :value="formData.nombre"
            @input="updateField('nombre', $event.target.value)"
            required
          />
        </div>

        <div class="form-row">
          <label for="arcgis-descripcion">Descripción <span class="required-indicator">*</span></label>
          <input
            id="arcgis-descripcion"
            type="text"
            class="input"
            :value="formData.descripcion"
            @input="updateField('descripcion', $event.target.value)"
            required
          />
        </div>

        <div class="form-row">
          <label for="arcgis-url">Url <span class="required-indicator">*</span></label>
          <div>
            <input
              id="arcgis-url"
              type="url"
              class="input"
              :value="formData.url"
              @input="updateField('url', $event.target.value)"
              required
            />
            <small class="error-text" v-if="formData.url && urlError">{{ urlError }}</small>
          </div>
        </div>

        <!-- Código -->
        <div class="form-row">
          <label for="arcgis-codigo">Código</label>
          <input
            id="arcgis-codigo"
            type="text"
            class="input"
            :value="formData.codigo"
            @input="updateField('codigo', $event.target.value)"
          />
        </div>

        <!-- Fuente -->
        <div class="form-row">
          <label for="arcgis-fuente">Fuente</label>
          <input
            id="arcgis-fuente"
            type="text"
            class="input"
            :value="formData.fuente"
            @input="updateField('fuente', $event.target.value)"
          />
        </div>

        <!-- Fecha -->


        <!-- Vulnerable -->
        <div class="form-row">
          <label for="arcgis-vulnerable">I. vulnerable Modelación/Geoprocesos? <span class="required-indicator">*</span></label>
          <select
            id="arcgis-vulnerable"
            class="input"
            :value="formData.esVulnerable"
            @change="updateField('esVulnerable', $event.target.value)"
            required
          >
            <option value="NO">NO</option>
            <option value="SI">SI</option>
          </select>
        </div>

        <!-- Cap Población -->
        <div class="form-row">
          <label for="arcgis-cap-poblacion">Cap población <span class="required-indicator">*</span></label>
          <select
            id="arcgis-cap-poblacion"
            class="input"
            :value="formData.capPoblacion"
            @change="updateField('capPoblacion', $event.target.value)"
            required
          >
            <option value="poligonos">Polígonos</option>
            <option value="puntos">Puntos</option>
            <option value="NO">NO</option>
          </select>
        </div>

        <!-- Orden -->
        <div class="form-row">
          <label for="arcgis-orden">Orden <span class="required-indicator">*</span></label>
          <div class="input-with-button">
            <input
              id="arcgis-orden"
              type="number"
              class="input"
              :value="formData.orden"
              @input="updateField('orden', parseInt($event.target.value))"
              required
            />
            <button type="button" class="btn-info" @click="showLayersOrderModal" title="Ver orden de capas existentes">?</button>
          </div>
        </div>

        <!-- Categoría -->
        <div class="form-row">
          <label for="arcgis-categoria">Categoría <span class="required-indicator">*</span></label>
          <select
            id="arcgis-categoria"
            class="input"
            :value="formData.categoria"
            @change="updateField('categoria', $event.target.value)"
          >
            <option value="-1" disabled>
              {{ categories.length === 0 ? "Cargando opciones..." : "Seleccione una categoría" }}
            </option>
            <option
              v-for="category in categories"
              :key="category.id"
              :value="category.id"
            >
              {{ category.name }}
            </option>
          </select>
        </div>

        <p class="note"><span class="required-indicator">(*)</span> Obligatorio</p>
      </div>
    </div>

    <!-- Modal de Información de Orden (Componente separado) -->
    <LayersOrderModal 
      ref="layersOrderModal" 
      :categories="categories" 
      @selected="updateField('orden', $event)"
    />
  </div>
</template>

<script>
import LayersOrderModal from "./LayersOrderModal.vue";

export default {
  name: "FormularioArcgisPaso1",

  components: {
    LayersOrderModal
  },

  model: {
    prop: "formData",
    event: "update:formData"
  },

  props: {
    formData: { type: Object, required: true },
    categories: { type: Array, required: true }
  },

  computed: {
    urlError() {
      const url = this.formData.url;
      if (!url) return null;

      // 1. Validar protocolo
      if (!/^https?:\/\//i.test(url)) {
        return "La URL debe comenzar con http:// o https://";
      }

      // 2. Validar que no termine en /
      if (url.endsWith("/")) {
        return "La URL no debe terminar en '/' (slash)";
      }

      // 3. Validar que no termine en número (índice de capa)
      if (/\/\d+$/.test(url)) {
        return "La URL no debe terminar con el índice (ej: /0). Colóquelo en el campo 'Código'.";
      }

      // 4. Validar formato general (simple)
      // Comprueba que después del protocolo haya algo que parezca un dominio/IP
      const pattern = /^https?:\/\/[^\s/$.?#].[^\s]*$/i;
      if (!pattern.test(url)) {
        return "El formato de la URL no es válido";
      }

      return null;
    }
  },

  methods: {
    updateField(key, newValue) {
      this.$emit("update:formData", { ...this.formData, [key]: newValue });
    },

    showLayersOrderModal() {
      this.$refs.layersOrderModal.show();
    }
  }
};
</script>

<style scoped>
.card {
  background: #fff;
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  padding: 0;
  margin-bottom: 20px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.card-header {
  background: #f5f5f5;
  padding: 12px 16px;
  border-bottom: 1px solid #dcdcdc;
}

.card-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
}

.card-body {
  padding: 20px;
}

/* ---------- GRID DEL FORM ---------- */
.form-grid {
  display: grid;
  grid-template-columns: 20rem 1fr;
  gap: 16px 24px;
}

/* Cada fila es un label + input */
.form-row {
  display: contents; /* Permite alineación en el grid tipo admin antiguo */
}

label {
  font-weight: 600;
  align-self: center;
}

/* ---------- INPUT GENERAL ---------- */
.input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #bbb;
  border-radius: 4px;
  background: #fff;
}

.input:focus {
  border-color: #3c8dbc;
  outline: none;
  box-shadow: 0 0 3px rgba(60,141,188,0.3);
}

/* Nota */
.note {
  grid-column: 1 / -1;
  margin-top: 10px;
  font-size: 13px;
  color: #555;
}

.required-indicator {
  color: red;
  font-weight: bold;
}

.error-text {
  color: #dc3545;
  font-size: 0.85em;
  margin-top: 5px;
  display: block;
}

/* ---------- NUEVOS ESTILOS ---------- */
.input-with-button {
  display: flex;
  gap: 8px;
  align-items: center;
}

.btn-info {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #3c8dbc;
  background-color: #fff;
  color: #3c8dbc;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;
}

.btn-info:hover {
  background-color: #3c8dbc;
  color: #fff;
}
</style>
